import { domain } from "../../Auth/Config";
const surveyFormUrl = domain + "/wp-json/gatsby-contact-form/v1/save";
const surveyDpvdUrl = domain + "/wp-json/contact-form-7/v1/contact-forms/27473/feedback";
const surveyServiceUrl = domain + "/wp-json/contact-form-7/v1/contact-forms/27475/feedback";
const surveyVipUrl = domain + "/wp-json/contact-form-7/v1/contact-forms/27476/feedback";
const surveyRegisterUrl = domain + "/wp-json/contact-form-7/v1/contact-forms/27474/feedback";
export { surveyFormUrl, surveyDpvdUrl, surveyServiceUrl, surveyVipUrl, surveyRegisterUrl };
